import { CONFIG } from '../../../config'
const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/checklist-operacional`

export function urlGetChecklists(tpId) {
  return `${BASE_URL}/${tpId}/checklists`
}

export function urlGetChecklist(tpId, id) {
  return `${BASE_URL}/${tpId}/checklists/${id}`
}

export function urlPostChecklist(tpId) {
  return `${BASE_URL}/${tpId}/checklists`
}

export function urlPutChecklist(tpId, id) {
  return `${BASE_URL}/${tpId}/checklists/${id}`
}

// PREENCHIMENTOS
export function urlGetPreenchimentos(tpId) {
  return `${BASE_URL}/${tpId}/preenchimentos`
}

export function urlGetPreenchimentoFormInit(tpId) {
  return `${BASE_URL}/${tpId}/preenchimentos/form-init`
}

export function urlGetPreenchimento(tpId, id) {
  return `${BASE_URL}/${tpId}/preenchimentos/${id}`
}

export function urlPostPreenchimento(tpId) {
  return `${BASE_URL}/${tpId}/preenchimentos`
}

export function urlPutPreenchimento(tpId, id) {
  return `${BASE_URL}/${tpId}/preenchimentos/${id}`
}

export function urlPutPreenchimentoRespostas(tpId, id) {
  return `${BASE_URL}/${tpId}/preenchimentos/${id}/respostas`
}

export function urlPostFinalizarPreenchimento(tpId, id) {
  return `${BASE_URL}/${tpId}/preenchimentos/${id}/finalizar`
}

export function urlDeletePreenchimento(tpId, id) {
  return `${BASE_URL}/${tpId}/preenchimentos/${id}`
}

export function urlReportPreenchimento(tpId, id) {
  return `${BASE_URL}/${tpId}/preenchimentos/${id}/imprimir?t=${localStorage.getItem('t')}`
}

export function urlReportPreenchimentoResultado(tpId, id) {
  return `${BASE_URL}/${tpId}/preenchimentos/${id}/imprimir-resultado?t=${localStorage.getItem('t')}`
}
